export default __webpack_public_path__ + "static/media/Savant's Straps of the Exiled.98bc7ab4.jpg";